module.exports = "# Sizzle\n\n## Content\n\n### Activity 1: Esmeralda & Goober Papercrafts!\n\n## Notes\n\nThe Papercraft prizes can be found in the Printables section on the Dashboard page.\n\nPrint the {r/Canada:colour}{r/:color} papercrafts or have the kids {r/Canada:colour}{r/:color} their own by using the black & white versions!\n\n\n# Intro Video\n\nYouTube: 0j3_79qkTY0\n\n## Notes\nIntro to Papercrafts activity (0:29).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/sections/30_classActivity/level6_papercrafts.md
// module id = 1803
// module chunks = 2